import { useContext } from "react";
import { AuthContext } from "./AuthProvider";

/**
 * Hook conveniente para acceder al estado de autenticación desde cualquier
 * componente descendiente de <AuthProvider>.
 *
 * Uso típico:
 *   function MiComponente() {
 *     const { status, user, login, logout } = useAuth();
 *     if (status !== 'authenticated') return null;
 *     return <p>Hola {user.preferred_username}</p>;
 *   }
 *
 * Si se llama desde un componente FUERA del AuthProvider, lanza error claro
 * en lugar de devolver undefined silenciosamente (sería bug difícil de diagnosticar).
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth() debe usarse dentro de <AuthProvider>");
  }
  return ctx;
}
